// extracted by mini-css-extract-plugin
module.exports = {"banner":"AuthorizeBanner_banner__1Pche","content":"AuthorizeBanner_content__3er7R","icon":"AuthorizeBanner_icon__2SO1e","cta":"AuthorizeBanner_cta__2GSYi"};